export default "__VITE_ASSET__cd43f24c__"